import { useComponentTranslation } from '@tebuto/functions/translation.components'
import ExtraSmallText from '@tebuto/typography/ExtraSmallText'

export default function Legend() {
    const { t } = useComponentTranslation()
    return (
        <div className="flex flex-col gap-2 mt-12 mb-6 md:mt-0 md:mb-6">
            <div className="flex gap-2 items-center">
                <div className="h-5 w-5 rounded-full widget-bg-primary-700" />
                <ExtraSmallText className="widget-text-secondary">
                    {t('booking.bookingCalendar.legend.isSelected')}
                </ExtraSmallText>
            </div>
            <div className="flex gap-2 items-center">
                <div className="h-5 w-5 rounded-full widget-bg-calendar-available-day" />
                <ExtraSmallText className="widget-text-secondary">
                    {t('booking.bookingCalendar.legend.hasAppointments')}
                </ExtraSmallText>
            </div>
            <div className="flex gap-2 items-center">
                <div className="h-5 w-5 rounded-full widget-bg-calendar-available-day border-2 widget-border-primary-700" />
                <ExtraSmallText className="widget-text-secondary">{t('today')}</ExtraSmallText>
            </div>
        </div>
    )
}
